import { ReactNode } from "react";
import { Button, ButtonProps } from "@mui/material";

interface AuthButtonProps extends Omit<ButtonProps, "children"> {
  children: ReactNode;
  width?: string;
}

const AuthButton = ({
  children,
  width = "100%",
  sx,
  ...props
}: AuthButtonProps) => {
  return (
    <Button
      variant="contained"
      loadingPosition="center"
      sx={{
        width,
        mb: 2,
        mt: 1.5,
        backgroundColor: "#FFF",
        color: "#000",
        padding: "15px 0",
        transition: "all 0.3s ease-in-out",
        fontWeight: 700,
        "&:hover": {
          backgroundColor: "white",
          boxShadow: (theme) =>
            `0px 0px 10px 2px ${theme.palette.primary.main}`,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default AuthButton;
